import axios from 'axios';

const API_URL = (import.meta.env.VITE_API_URL || 'http://localhost:5001').replace(/\/api$/, '');

function authHeaders(token: string | null) {
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export interface ApiSavedView {
  id: string;
  entityKey: string;
  name: string;
  state: unknown;
  ownerId: string;
  ownerEmail: string;
  isShared: boolean;
  isSystem: boolean;
  updatedAt?: string;
}

export interface ApiSavedDashboard {
  id: string;
  name: string;
  columns: unknown[];
  ownerId: string;
  ownerEmail: string;
  isShared: boolean;
  isSystem: boolean;
  updatedAt?: string;
}

export async function listSavedViewsApi(
  token: string | null,
  entityKey: string
): Promise<ApiSavedView[]> {
  const { data } = await axios.get(`${API_URL}/api/saved-views`, {
    params: { entity: entityKey },
    headers: authHeaders(token),
  });
  return data;
}

export async function createSavedViewApi(
  token: string | null,
  payload: { entityKey: string; name: string; state: unknown; isShared: boolean }
): Promise<ApiSavedView> {
  const { data } = await axios.post(`${API_URL}/api/saved-views`, payload, {
    headers: authHeaders(token),
  });
  return data;
}

export async function updateSavedViewApi(
  token: string | null,
  id: string,
  patch: { name?: string; state?: unknown; isShared?: boolean }
): Promise<ApiSavedView> {
  const { data } = await axios.put(`${API_URL}/api/saved-views/${id}`, patch, {
    headers: authHeaders(token),
  });
  return data;
}

export async function deleteSavedViewApi(token: string | null, id: string): Promise<void> {
  await axios.delete(`${API_URL}/api/saved-views/${id}`, { headers: authHeaders(token) });
}

export async function listSavedDashboardsApi(
  token: string | null
): Promise<ApiSavedDashboard[]> {
  const { data } = await axios.get(`${API_URL}/api/saved-dashboards`, {
    headers: authHeaders(token),
  });
  return data;
}

export async function createSavedDashboardApi(
  token: string | null,
  payload: { name: string; columns: unknown[]; isShared: boolean }
): Promise<ApiSavedDashboard> {
  const { data } = await axios.post(`${API_URL}/api/saved-dashboards`, payload, {
    headers: authHeaders(token),
  });
  return data;
}

export async function updateSavedDashboardApi(
  token: string | null,
  id: string,
  patch: { name?: string; columns?: unknown[]; isShared?: boolean }
): Promise<ApiSavedDashboard> {
  const { data } = await axios.put(`${API_URL}/api/saved-dashboards/${id}`, patch, {
    headers: authHeaders(token),
  });
  return data;
}

export async function deleteSavedDashboardApi(token: string | null, id: string): Promise<void> {
  await axios.delete(`${API_URL}/api/saved-dashboards/${id}`, {
    headers: authHeaders(token),
  });
}
